import styled from 'styled-components';
import { Text } from './Text';
import { ReactNode } from 'react';
import { FlexRowMiddle } from './Flex';

const StyledCategoryHeader = styled(FlexRowMiddle)`
	column-gap: 1rem;
`;

const StyledLine = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${({ theme }) => theme.text_title_alt};
`;

export function CategoryHeader({ children }: { children: ReactNode }) {
	return (
		<StyledCategoryHeader>
			<StyledLine />
			<Text $color="text_title_alt" $size="1.2rem" $weight="400" style={{ whiteSpace: 'nowrap' }}>
				{children}
			</Text>
			<StyledLine />
		</StyledCategoryHeader>
	);
}
